import { createContext } from "react";

export const VishcorpSurchargeContext = createContext();
